import { useState, useEffect } from 'react';
import '../styles/header.css';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img src="/images/ctump/logo.gif" alt="CTUMP Logo" className="logo-icon" />
          <span className="logo-text">CTUMP</span>
        </div>

        <button 
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li><a href="#mission" onClick={(e) => { e.preventDefault(); handleNavClick('#mission'); }}>Sứ mạng</a></li>
            <li><a href="#timeline" onClick={(e) => { e.preventDefault(); handleNavClick('#timeline'); }}>Lịch sử</a></li>
            <li><a href="#facilities" onClick={(e) => { e.preventDefault(); handleNavClick('#facilities'); }}>Cơ sở vật chất</a></li>
            {/*<li><a href="#education" onClick={(e) => { e.preventDefault(); handleNavClick('#education'); }}>Đào tạo</a></li>*/}
            <li><a href="#research" onClick={(e) => { e.preventDefault(); handleNavClick('#research'); }}>Nghiên cứu</a></li>
            <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}>Liên hệ</a></li>
          </ul>
        </nav>

        {/*<div className="header-cta">
          <button className="btn btn-primary">Tuyển sinh</button>
        </div>*/}
      </div>
    </header>
  );
}